import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GlossaryComponent } from '@app/main/glossary/glossary.component';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [{ path: '', component: GlossaryComponent, canActivate: [MsalGuard] }];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class GlossaryRoutingModule {}
